import { UsersInterface } from '../../..';

export class DancePartnerSearchPostingUserDto implements UsersInterface {
  id: string;
  firstName: string;
  lastName: string;
  imageUrl: string;
  username: string;
}
